module.exports = __webpack_public_path__ + "img/txt.1e8cea9d.svg";